import { Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

type ArtistBoxSkeletonProps = {}

export const ArtistBoxSkeleton: Cell<ArtistBoxSkeletonProps> = () => (
  <Stack
    spacing={4}
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
  >
    <Skeleton variant="circular" width={64} height={64} />
    <SkeletonText variant="small" width="75%" />
  </Stack>
)
